import { useState } from "react";
import "./NotificationPanel.css";
import Modal from "../Modal/Modal";
import { CloseIcon } from "../../Assets/assets";
import { isValidObject } from "../../Services/validators";
import { formatTimestamp } from "../../Utils/Constants/Constants";

export default function NotificationPanel(props) {
  const [activeTab, setActiveTab] = useState("inbox");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <Modal
      show={true}
      canIgnore={true}
      transparentBackgroundColor={true}
      onClose={() => {
        props.navigate(-1);
      }}
      height="inherit-parent-height"
      width="width-360px"
      minWidth="none"
      borderRadius="none"
      background="background-color-tertiaryColor2"
      position="position-absolute bottom-0 right-0"
    >
      <div className="inherit-parent-height" data-cy="NOTIFICATIONS-PANEL">
        <div className="display-flex flex-justify-content-space-between flex-align-items-center padding-large">
          <div className="font-color-tertiaryColor font-size-larger">
            Notifications
          </div>
          <div className="display-flex">
            {props?.notifications.counts?.unread > 0 && (
              <div
                className="margin-right-large cursor-pointer"
                onClick={() => props.updateNotification("READ_ALL")}
                data-cy="MARK-ALL-AS-READ"
              >
                <ReadAllIcon />
              </div>
            )}

            <div
              onClick={() => {
                props.navigate(-1);
              }}
              style={{
                height: "16px",
                width: "16px"
              }}
              className="cursor-pointer"
              data-cy="CLOSE-NOTIFICATIONS-PANEL"
            >
              <CloseIcon color="var(--tertiaryColor6)" />
            </div>
          </div>
        </div>
        <div
          className=" font-color-tertiaryColor font-size-medium inherit-parent-width"
          style={{ height: "calc(100% - 59px)" }}
        >
          <NotificationTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            counts={props.notifications.counts}
          />

          {/* <div className="flex-justify-content-space-between margin-horizontal-larger padding-vertical-default"> */}
          {/* <div className="display-flex">
          <div className="padding-right-small">Newest</div>
          <SortIcon color="var(--tertiaryColor5)" />
        </div> */}
          {/* <div className="text-right text-sm text-gray-400 cursor-pointer hover:text-white">
          Mark all as read
        </div> */}
          {/* </div> */}

          {/* Notification cards */}
          <div
            className="inherit-parent-height overflow-scroll"
            style={{ height: "calc(100% - 41px)" }}
          >
            {isValidObject(props.notifications?.[activeTab]) ? (
              Object.values(props.notifications?.[activeTab])?.map(
                (notification, index) => (
                  <div
                    key={index}
                    className={`padding-large flex-justify-content-space-between inherit-parent-width notification-card ${
                      notification.read
                        ? "font-color-tertiaryColor6"
                        : "font-color-tertiaryColor"
                    } `}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    style={{ borderBottom: "1px solid var(--tertiaryColor9)" }}
                    data-cy={`${activeTab}-NOTIFICATION-CARD-${index}`}
                  >
                    <div
                      className="display-flex"
                      style={{ width: "calc(100% - 80px)" }}
                    >
                      <div className="margin-right-small">
                        <Dot visibility={!notification.read} />
                      </div>
                      <div>
                        <div className="text-two-line-ellipsis">
                          {notification.description}
                        </div>
                        <div className="display-flex padding-top-small">
                          <div className=" font-size-small font-color-tertiaryColor6">
                            {formatTimestamp(notification.timestamp)}
                          </div>
                          <div className="flex-justify-content-center flex-align-items-center margin-horizontal-small">
                            {" "}
                            <LineIcon />
                          </div>
                          <div className="font-size-small">Missed Call</div>
                        </div>
                      </div>
                    </div>
                    {hoveredIndex === index && activeTab === "inbox" ? (
                      <div className="display-flex">
                        <div
                          className="cursor-pointer margin-right-large"
                          onClick={() =>
                            props.updateNotification(
                              notification.read ? "UNREAD" : "READ",
                              notification.ruleId,
                              notification.documentId
                            )
                          }
                          data-cy={`${
                            notification.read ? "UNREAD" : "READ"
                          }-NOTIFICATION-INDEX-${index}`}
                        >
                          <ReadIcon read={notification.read} />
                        </div>
                        <div
                          className="cursor-pointer"
                          onClick={() =>
                            props.updateNotification(
                              notification?.archived ? "UNARCHIVE" : "ARCHIVE",
                              notification.ruleId,
                              notification.documentId
                            )
                          }
                          data-cy={`${
                            notification?.archived ? "UNARCHIVE" : "ARCHIVE"
                          }-NOTIFICATION-INDEX-${index}`}
                        >
                          <ArchiveIcon archived={notification?.archived} />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <ThreeDotsOptionIcon />
                      </div>
                    )}
                  </div>
                )
              )
            ) : (
              <div className="inherit-parent-height flex-align-items-center flex-justify-content-center">
                <Fallback activeTab={activeTab} />
              </div>
            )}
            {isValidObject(props.notifications?.[activeTab]) &&
              Object.values(props.notifications?.[activeTab])?.length > 49 &&
              !props.notification.notificationState?.[activeTab].loading &&
              props.notification.notificationState?.[activeTab].hasMore && (
                <div
                  className="text-align-center padding-large cursor-pointer"
                  onClick={() => {
                    props.notification.loadMoreNotifications(activeTab);
                  }}
                  data-cy="LOAD-MORE-NOTIFICATION-BUTTON"
                >
                  Load more
                </div>
              )}

            {props.notification.notificationState?.[activeTab].loading && (
              <div className="text-align-center padding-large">Loading...</div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
function NotificationTabs(props) {
  const tabs = ["inbox", "archived"];

  return (
    <div className="display-flex flex-justify-content-space-between margin-horizontal-medium padding-vertical-default">
      {tabs.map((tab) => (
        <div
          key={tab}
          onClick={() => props.setActiveTab(tab)}
          className={`padding-bottom-small width-50-percentage text-align-center text-capitalize display-flex  flex-align-items-center flex-justify-content-center ${
            props.activeTab === tab
              ? "font-color-tertiaryColor"
              : "font-color-tertiaryColor6"
          }`}
          style={{
            borderBottom:
              props.activeTab === tab
                ? "2px solid var(--tertiaryColor5)"
                : "2px solid var(--tertiaryColor9)"
          }}
          data-cy={`${tab}-TAB-${
            props.activeTab === tab ? "ACTIVE" : "INACTIVE"
          }`}
        >
          {tab.toUpperCase()}
          {tab !== "archived" && props?.counts?.unread > 0 && (
            <div
              className="font-color-secondaryColor font-size-small margin-left-default"
              data-cy="UNREAD-COUNT"
            >
              {props?.counts?.unread}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// const SortIcon = (props) => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="16"
//       height="16"
//       viewBox="0 0 16 16"
//       fill="none"
//     >
//       <path
//         d="M8 12.1526L8 3.26367"
//         stroke="var(--tertiaryColor6)"
//         strokeWidth="1.4"
//         strokeLinecap="round"
//       />
//       <path
//         d="M8 12.7359L11.7037 9.03223"
//         stroke="var(--tertiaryColor6)"
//         strokeWidth="1.4"
//         strokeLinecap="round"
//       />
//       <path
//         d="M8.00058 12.7359L4.29688 9.03223"
//         stroke="var(--tertiaryColor6)"
//         strokeWidth="1.4"
//         strokeLinecap="round"
//       />
//     </svg>
//   );
// };

const Dot = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
    >
      <circle
        cx="3"
        cy="6"
        r="3"
        fill={`${
          props.visibility ? "var(--secondaryColor)" : "rgba(0, 0, 0, 0);"
        }`}
      />
    </svg>
  );
};

const ReadIcon = (props) => {
  return props.read ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.80429 2.04337C7.94886 1.97572 8.12036 1.98726 8.25591 2.07763L13.7943 5.7699C13.9227 5.8555 13.9998 5.9996 13.9998 6.15391C13.9998 6.30823 13.9227 6.45233 13.7943 6.53793L8.25591 10.2302C8.10088 10.3336 7.89893 10.3336 7.7439 10.2302L2.20553 6.53793C2.07713 6.45233 2 6.30823 2 6.15391C2 5.9996 2.07713 5.8555 2.20553 5.7699L7.7439 2.07763L7.80429 2.04337ZM3.29355 6.15391L7.9999 9.29091L12.7063 6.15391L7.9999 3.01602L3.29355 6.15391Z"
        fill="var(--tertiaryColor6)"
      />
      <path
        d="M2 12.308V6.15391C2 5.89902 2.20663 5.69238 2.46153 5.69238C2.71643 5.69238 2.92306 5.89902 2.92306 6.15391V12.308L2.92667 12.3837C2.94415 12.5598 3.02219 12.7253 3.14842 12.8516C3.2926 12.9958 3.48808 13.0769 3.69198 13.0769H12.3078C12.5117 13.0769 12.7072 12.9958 12.8514 12.8516C12.9956 12.7074 13.0767 12.5119 13.0767 12.308V6.15391C13.0767 5.89902 13.2834 5.69238 13.5383 5.69238C13.7932 5.69238 13.9998 5.89902 13.9998 6.15391V12.308C13.9997 12.7567 13.8213 13.1869 13.504 13.5042C13.1867 13.8215 12.7565 13.9999 12.3078 14H3.69198C3.24327 13.9999 2.81308 13.8215 2.49579 13.5042C2.21804 13.2265 2.04654 12.8623 2.00811 12.4748L2 12.308Z"
        fill="var(--tertiaryColor6)"
      />
      <path
        d="M5.82746 8.28911C6.0077 8.10887 6.29986 8.10887 6.4801 8.28911C6.66034 8.46935 6.66034 8.76151 6.4801 8.94175L2.78785 12.634C2.60761 12.8143 2.31545 12.8143 2.13521 12.634C1.95498 12.4538 1.95498 12.1616 2.13521 11.9814L5.82746 8.28911Z"
        fill="var(--tertiaryColor6)"
      />
      <path
        d="M9.51971 8.28911C9.67743 8.13139 9.92108 8.11131 10.1002 8.22962L10.1723 8.28911L13.8646 11.9814L13.9241 12.0535C14.0424 12.2327 14.0223 12.4763 13.8646 12.634C13.7069 12.7917 13.4632 12.8118 13.2841 12.6935L13.212 12.634L9.51971 8.94175L9.46022 8.86964C9.34191 8.69049 9.36199 8.44683 9.51971 8.28911Z"
        fill="var(--tertiaryColor6)"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_4905_22474)">
        <path
          d="M8 12.6663H3.33333C2.97971 12.6663 2.64057 12.5259 2.39052 12.2758C2.14048 12.0258 2 11.6866 2 11.333V4.66634C2 4.31272 2.14048 3.97358 2.39052 3.72353C2.64057 3.47348 2.97971 3.33301 3.33333 3.33301H12.6667C13.0203 3.33301 13.3594 3.47348 13.6095 3.72353C13.8595 3.97358 14 4.31272 14 4.66634V7.99967"
          stroke="var(--tertiaryColor6)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 13C11 13.5304 11.2107 14.0391 11.5858 14.4142C11.9609 14.7893 12.4696 15 13 15C13.5304 15 14.0391 14.7893 14.4142 14.4142C14.7893 14.0391 15 13.5304 15 13C15 12.4696 14.7893 11.9609 14.4142 11.5858C14.0391 11.2107 13.5304 11 13 11C12.4696 11 11.9609 11.2107 11.5858 11.5858C11.2107 11.9609 11 12.4696 11 13Z"
          fill="var(--tertiaryColor6)"
          stroke="var(--tertiaryColor6)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 4.66699L8 8.66699L14 4.66699"
          stroke="var(--tertiaryColor6)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4905_22474">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ArchiveIcon = (props) => {
  return props.archived ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_4813_3616)">
        <path
          d="M5.33413 2.66699H12.6675C13.0211 2.66699 13.3602 2.80747 13.6103 3.05752C13.8603 3.30756 14.0008 3.6467 14.0008 4.00033C14.0008 4.35395 13.8603 4.69309 13.6103 4.94313C13.3602 5.19318 13.0211 5.33366 12.6675 5.33366H8.00079M5.33413 5.33366H3.33413C3.02929 5.33384 2.7336 5.22956 2.49631 5.0382C2.25903 4.84683 2.09448 4.57994 2.03009 4.28198C1.9657 3.98402 2.00534 3.673 2.14243 3.40073C2.27951 3.12845 2.50576 2.91137 2.78346 2.78566"
          stroke="var(--tertiaryColor6)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33398 5.33301V11.9997C3.33398 12.3533 3.47446 12.6924 3.72451 12.9425C3.97456 13.1925 4.3137 13.333 4.66732 13.333H11.334C11.5909 13.333 11.8424 13.2587 12.0581 13.1192C12.2738 12.9796 12.4446 12.7807 12.55 12.5463M12.6673 9.99967V5.33301"
          stroke="var(--tertiaryColor6)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66602 8H7.99935"
          stroke="var(--tertiaryColor6)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 2L14 14"
          stroke="var(--tertiaryColor6)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4813_3616">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3 5.37324V11.9789C3 12.3823 3.15051 12.7692 3.41842 13.0545C3.68633 13.3397 4.04969 13.5 4.42857 13.5H11.5714C11.9503 13.5 12.3137 13.3397 12.5816 13.0545C12.8495 12.7692 13 12.3823 13 11.9789V5.37324M6.66667 7.90845H9.33333M2 3.85211C2 3.49351 2.14048 3.14959 2.39052 2.89602C2.64057 2.64245 2.97971 2.5 3.33333 2.5H12.6667C13.0203 2.5 13.3594 2.64245 13.6095 2.89602C13.8595 3.14959 14 3.49351 14 3.85211C14 4.21072 13.8595 4.55463 13.6095 4.8082C13.3594 5.06177 13.0203 5.20423 12.6667 5.20423H3.33333C2.97971 5.20423 2.64057 5.06177 2.39052 4.8082C2.14048 4.55463 2 4.21072 2 3.85211Z"
        stroke="var(--tertiaryColor6)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ThreeDotsOptionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6.89961 2.1002C6.89961 2.59725 6.49667 3.0002 5.99961 3.0002C5.50255 3.0002 5.09961 2.59725 5.09961 2.1002C5.09961 1.60314 5.50255 1.2002 5.99961 1.2002C6.49667 1.2002 6.89961 1.60314 6.89961 2.1002Z"
        fill="var(--tertiaryColor6)"
      />
      <path
        d="M6.89961 6.0002C6.89961 6.49725 6.49667 6.9002 5.99961 6.9002C5.50255 6.9002 5.09961 6.49725 5.09961 6.0002C5.09961 5.50314 5.50255 5.1002 5.99961 5.1002C6.49667 5.1002 6.89961 5.50314 6.89961 6.0002Z"
        fill="var(--tertiaryColor6)"
      />
      <path
        d="M5.99961 10.8002C6.49667 10.8002 6.89961 10.3973 6.89961 9.9002C6.89961 9.40314 6.49667 9.0002 5.99961 9.0002C5.50255 9.0002 5.09961 9.40314 5.09961 9.9002C5.09961 10.3973 5.50255 10.8002 5.99961 10.8002Z"
        fill="var(--tertiaryColor6)"
      />
    </svg>
  );
};

const LineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
    >
      <path d="M0 1H12" stroke="var(--tertiaryColor6)" strokeOpacity="0.16" />
    </svg>
  );
};

const FallbackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M20.0005 6.2002C20.8841 6.2002 21.6005 6.91654 21.6005 7.8002V13.8002C21.6005 14.6839 20.8841 15.4002 20.0005 15.4002C19.1168 15.4002 18.4005 14.6839 18.4005 13.8002V7.8002C18.4005 6.91654 19.1168 6.2002 20.0005 6.2002Z"
        fill="var(--tertiaryColor6)"
      />
      <path
        d="M27.3545 18.4462C26.7296 17.8214 26.7296 16.8083 27.3545 16.1835L31.5971 11.9408C32.2219 11.316 33.235 11.316 33.8598 11.9408C34.4847 12.5657 34.4847 13.5787 33.8598 14.2036L29.6172 18.4462C28.9924 19.0711 27.9793 19.0711 27.3545 18.4462Z"
        fill="var(--tertiaryColor6)"
      />
      <path
        d="M12.6465 18.4462C12.0217 19.0711 11.0086 19.0711 10.3838 18.4462L6.14111 14.2036C5.51628 13.5787 5.51628 12.5657 6.14111 11.9408C6.76595 11.316 7.77902 11.316 8.40386 11.9408L12.6465 16.1835C13.2713 16.8083 13.2713 17.8214 12.6465 18.4462Z"
        fill="var(--tertiaryColor6)"
      />
      <path
        d="M36.0004 24.6001C36.884 24.6001 37.6004 25.3164 37.6004 26.2001V30.2001C37.6004 32.1883 35.9886 33.8001 34.0004 33.8001L6.00039 33.8001C4.01217 33.8001 2.40039 32.1883 2.40039 30.2001V26.2001C2.40039 25.3164 3.11674 24.6001 4.00039 24.6001C4.88405 24.6001 5.60039 25.3164 5.60039 26.2001L5.60039 30.2001C5.60039 30.421 5.77948 30.6001 6.00039 30.6001L34.0004 30.6001C34.2213 30.6001 34.4004 30.421 34.4004 30.2001V26.2001C34.4004 25.3164 35.1167 24.6001 36.0004 24.6001Z"
        fill="var(--tertiaryColor6)"
      />
    </svg>
  );
};

const Fallback = ({ activeTab }) => {
  return (
    <div
      className="display-flex flex-direction-column flex-align-items-center text-align-center"
      style={{ width: "calc(100% - 140px)" }}
    >
      <FallbackIcon />
      <div>
        You have no {activeTab === "archived" ? "archived" : ""} notifications.
      </div>
    </div>
  );
};

const ReadAllIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.66602 8.00033L7.99935 11.3337L14.666 4.66699"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33398 8.00033L4.66732 11.3337M8.00065 8.00033L11.334 4.66699"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
